/** @jsx jsx */

import { Fragment as _, memo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableButton from 'components/lib/EditableBtn';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Media from 'components/lib/Media';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import Certificate, {
  CertificateTextFields,
  CertificateTextField,
} from './Certificate';
import CertificateTemplates from './CertificateTemplates';

const Components = {
  Row,
  Column,
  Text: EditableText,
  CertificateMedia({ children, ...props }) {
    return <div style={{ padding: '20px 0 20px 0' }}>{children}</div>;
  },
  Certificates: ({ children, ...props }) => children,
  Certificate,
  CertificateTextFields,
  CertificateTextField,
  CertificateTemplate: ({ children, ...props }) => children,
  CertificateTemplates,
  Image,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton,
  Video,
  SVG,
  Media,
};

const CertificateDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default CertificateDisplay;
